export const title = 'Contact Information';
export const contactTitle = 'Job Information';

export const link = 'Submit';
